/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";

const ApplyForAPermit = () => {

    return (
        <main>
        </main>
    );
};


export { ApplyForAPermit };
